import { useAiSettings } from "../../../api/hooks";
import { useFeatureFlagQuery } from "../../../hooks/useFeatureFlag";

/** Whether the Goal Quality Coach is available: coaching FF + the company setting. */
export const useGoalCoachEnabled = (): boolean => {
	const { value: aiEnabled } = useFeatureFlagQuery("ff-is-ai-enabled", false);
	const { value: coachingEnabled } = useFeatureFlagQuery("ff-is-coaching-enabled", false);

	const { data: aiSettings } = useAiSettings();
	const goalCoachingEnabled = aiSettings?.goalCoachingEnabled ?? false;

	return aiEnabled && coachingEnabled && goalCoachingEnabled;
};
